import { generatePath, useNavigate } from 'react-router';
import type { IPendingReview } from '~/domain/ShiftReview';
import { fireDashboardPendingReviewClicked } from '~/posthogs/events';
import { routes } from '~/routes';
import { mapPendingReviewToShiftCard } from './mapPendingReviewToShiftCard';

/** Drives a PendingReviewShiftCard: card data + the tap-through to the adjustments/details screen. */
export const usePendingReviewShiftCard = (review: IPendingReview) => {
  const navigate = useNavigate();

  const cardData = mapPendingReviewToShiftCard(review);

  const onCardClick = () => {
    fireDashboardPendingReviewClicked();

    if (review.hasAdjustment) {
      navigate(generatePath(routes.jobAdjustment, { jobId: review.id }), {
        state: { job_id: review.id },
      });

      return;
    }

    navigate(generatePath(routes.jobDetails, { jobId: review.id }));
  };

  return { cardData, onCardClick };
};
